import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import projects from "../../constants/projects.js";

const ProjectCard = ({ project }) => (
  <Col md={3} className="project-card">
    <div className="project-card-inner">
      <img
        src={project.image}
        alt={project.title}
        className="project-image"
      />
      <div className="project-details">
        <a
          href={project.link}
          target="_blank"
          rel="noopener noreferrer"
          className="project-title-link"
        >
          <h3 className="project-title">{project.title}</h3>
        </a>
        <p className="project-description">{project.description}</p>
      </div>
    </div>
  </Col>
);

function Projects() {
  const [showAll, setShowAll] = useState(false);

  return (
    <section id="projects" className="projects-section">
      <Container>
        <h2 className="section-header">
          <span className="purple">PROJECTS</span>
        </h2>
        <Row className="project-row">
          {projects.slice(0, 4).map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </Row>
        <Row className={`project-row projects-extra${showAll ? " projects-extra-visible" : ""}`}>
          {projects.slice(4).map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </Row>
        <button
          className="projects-toggle-btn"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? "Show Less" : "Show More"}
        </button>
      </Container>
    </section>
  );
}

export default Projects;
